/**
 * Who serves a route (`RouteDef.hosts`, routes.ts): the stage's cloud API, an on-prem node's state service, or both
 * (PLAN §10.1: one contract, two hosts). Its own module because every route table imports it and `routes.ts` imports
 * every route table: a value there would be read before it is initialised.
 */
export type RouteHost = 'cloud' | 'node';

/** Served by both hosts: the rundown API, studios, show styles, productions and playout (`@acp/handlers`, shared). */
export const BOTH_HOSTS: readonly RouteHost[] = ['cloud', 'node'];

/** Served by a node only: a main/backup pair's own routes (PLAN §8.4). */
export const NODE_ONLY: readonly RouteHost[] = ['node'];
